// extracted by mini-css-extract-plugin
module.exports = {"modal":"PdfModal_modal__2uoF7","modalContent":"PdfModal_modalContent__2KdVR","close":"PdfModal_close__27WGT","iframe":"PdfModal_iframe__2Y_0H"};